// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"715":"list","962":"home","996":"chunk-common"}[chunkId] || chunkId) + "." + {"570":"62940b08","715":"86f8982f","962":"a7769b3e","996":"27709396"}[chunkId] + ".js";
};